export default __webpack_public_path__ + "static/media/ic-home-account.91092d89.svg";